// Coach-aware plan helpers shared by the ledger (day-data's plan derivation)
// and the review surfaces.

import type { SportIconKind } from '../components/SportIcon';

// v2 activity category → sport icon kind (mirrors REVIEW WeekByWeekPlan).
const COACH_CATEGORY_KIND: Record<string, SportIconKind> = {
  strength: 'strength',
  run: 'run',
  mixed: 'mixed',
  other: 'mixed',
};

/**
 * Sport icon kind for a coach prescription. Categories drive most of it, but
 * fixed activities like Padel come back as category='other' (the LLM doesn't
 * prescribe over them, it just surfaces the commitment). Give Padel its padel
 * icon by name so it reads consistently with the static schedule. Rest wins.
 */
export function coachKind(
  kind: 'training' | 'rest',
  category: string,
  name: string,
): SportIconKind {
  if (kind === 'rest') return 'rest';
  if (/padel/i.test(name)) return 'padel';
  return COACH_CATEGORY_KIND[category] ?? 'mixed';
}
